/**
 * @generated SignedSource<<e2b4a726df35872dcadaa133662258a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VideoStatusEnum = "pending" | "processed" | "processing" | "processing_failed" | "processing_queued" | "processing_rejected" | "unprocessed";
import { FragmentRefs } from "relay-runtime";
export type StoredVideo_Video$data = {
  readonly id: string;
  readonly optimizedUrl: string;
  readonly posterUrl: string | null | undefined;
  readonly status: VideoStatusEnum;
  readonly " $fragmentSpreads": FragmentRefs<"Video_Video">;
  readonly " $fragmentType": "StoredVideo_Video";
};
export type StoredVideo_Video$key = {
  readonly " $data"?: StoredVideo_Video$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoredVideo_Video">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoredVideo_Video",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optimizedUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "posterUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Video_Video"
    }
  ],
  "type": "Video",
  "abstractKey": null
};

(node as any).hash = "6633d79c681f1eb53e22f0855e735272";

export default node;
